import APIContext from 'contexts/base/APIContext'

export default class LogBooksReferencesContext extends APIContext{
  static contextName = 'logBooksReferences'

  set = async(item, {...options}={}) => {
    const { data } = await this.performRequest('set')({...item, options})
    this.setState({list: data})
    return data
    
  }
}
